module.exports = __webpack_public_path__ + "static/image2-3ee20c818e3079654c7b4e5c987cfcc3.jpg";